<template>
  <div>
    <SsgMessagebox
      titles="款项金额"
      v-if="maskshow"
      @sub="onmoney"
      width="500px"
      height="auto"
      @shut="shutmount"
    >
      <div class="mtitle">请填写您收到的款项金额</div>
      <div class="minput">
        <el-input v-model="money" type="number"></el-input>
        <span class="left">￥</span>
        <span class="right">元</span>
      </div>
    </SsgMessagebox>
     <div class='authority' v-if='status==true'>
		<div class='content'>
			 <p>您没有权限查看页面</p>
		   <p>如需开通请联系系统管理员</p></div>
		</div>
    <div>
   <div  class="mask" @click="hidemask" v-if="inshow == true">
      <div class="industrydiv" @click="hideindu($event)">
        <div class="industrydiv_top">
          <div class="header">
            <div class="h4">
              <h4>所属行业</h4>
            </div>
            <div class="shut">
              <div @click="onshut"></div>
            </div>
          </div>
          <div class="search">
            <div class="searchinput">
              <div class="in_boxs">
                <div class="in_box" v-if="checkindividual!=''">
                  <div
                    class="text"
                    :style="'width:'+checkindividual.length*12+'px'"
                  >{{checkindividual}}</div>
                  <span @click="deletein(checkindividual)">×</span>
                </div>
              </div>
              <span v-if="!checkindividual" class="centerConter">请选择职业名称</span>
              <!-- <input type="text" placeholder="请输入职业名称"  /> -->
            </div>
            <div class="searchresult" v-if="searchtext !=''">
              <ul>
                <li
                  v-for="(v,k) in get_list" 
                  :key="k"
                  v-if="v.indexOf(searchtext) != -1"
                  :class="v == checkindividual ? 'exist' : ''"
                  @click="oncheck(v)"
                >{{v}}</li>
              </ul>
            </div>
            <button @click="onindustry">确定</button>
          </div>
        </div>
        <div class="industry_main">
          <div class="industrydiv_left">
            <ul>
              <li
                v-for="(v,k) in industrylist"
                :key="k"
                :class="v.id == checkid ? 'checked' : ''"
                @click="onchecked(v.id)"
              >
                <span v-for="(i,j) in v.general.split(',')" :key="j">{{i}}</span>
              </li>
            </ul>
          </div>
          <div class="industrydiv_right">
            <ul v-for="(v,k) in industrylist" :key="k" v-if="v.id == checkid">
              <li
                v-for="(i,j) in v.individual"
                :key="j"
                @click="oncheck(i)"
                :class="i == checkindividual ? 'checked' : ''"
              >{{i}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div  v-if="status==false">
   <div class="ibox">
      <div class="box">
        <p class="return" @click="back">返回首页</p>
        <span class="line">|</span>
        <p class="contract">系统设置</p>
        <span class="lines">></span>
        <p class="contract">企业设置</p>
      </div>
      <div class="mainTitle">企业设置</div>
      <div class="table">
        <h4>企业信息</h4>
        <div class="operating" @click="onshow({editShow})">
          <i class="el-icon-edit-outline" style="font-size:12px;margin-right:4px"></i>编辑
        </div>
      </div>
      <div class="show" v-if="show">
        <div class="dataitems">
          <div class="item">
            <div class="message">企业编码:</div>
            <div class="i_content">{{baseInfo.companyCode}}</div>
          </div>
          <div class="item">
            <div class="message">企业名称:</div>
            <div class="i_content">{{baseInfo.companyName}}</div>
          </div>

          <div class="item">
            <div class="message">企业简称:</div>
            <div class="i_content">{{baseInfo.aliasName}}</div>
          </div>
          <div class="item">
            <div class="message">所属行业:</div>
            <div class="i_content">{{baseInfo.industryName}}</div>
          </div>
          <div class="item">
            <div class="message">企业规模:</div>
            <div class="i_content">{{baseInfo.scale}}</div>
          </div>
          <div class="item">
            <div class="message">企业所在地:</div>
            <div class="i_content">{{baseInfo.region}}</div>
          </div>
          <div class="item">
            <div class="message">详细地址:</div>
            <div class="i_content">{{baseInfo.address}}</div>
          </div>
          <div class="item">
            <div class="message">邮政编码:</div>
            <div class="i_content">{{baseInfo.zipCode}}</div>
          </div>
        </div>
      </div>
      <div class="edit" v-if="!show">
        <div style="display:-webkit-inline-box;display:flex;margin-left:20px;">
          <div class="dataitems">
            <el-form
              :inline="true"
              ref="edit"
              :rules="rules"
              :model="updateBaseInfo"
              label-position="right"
              label-width="100px"
            >
              <div class="item">
                <el-form-item
                  label="企业名称"
                  prop="companyName"
                  style="width: 600px;margin-bottom:20px"
                >
                  <el-input
                    v-model="updateBaseInfo.companyName"
                    maxlength="30"
                    :disabled="authState >= 1 && authState <= 9"
                  ></el-input>
                </el-form-item>
                <el-form-item label="企业简称" prop="aliasName" style="width: 600px;margin-bottom:20px">
                  <el-input v-model="updateBaseInfo.aliasName" maxlength="10"></el-input>
                </el-form-item>
                <el-form-item
                  label="所属行业"
                  prop="industryName"
                  style="width: 600px;margin-bottom:20px"
                >
                  <el-input
                    v-model="updateBaseInfo.industryName"
                    placeholder="请输入行业类别"
                    @focus="ishow"
                  />
                  <!-- <el-input v-model="baseInfo.industry_name"></el-input> -->
                </el-form-item>
                <el-form-item label="企业规模" prop="scale" style="width: 600px;margin-bottom:20px">
                  <el-select v-model="updateBaseInfo.scale" placeholder="请选择">
                    <el-option
                      v-for="item in scales"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="企业所在地" prop="region" style="width: 600px;margin-bottom:20px">
                  <el-cascader
                    :clearable="true"
                    v-model="region"
                    placeholder="请选择"
                    :options="options"
                    filterable
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址" prop="address" style="width: 600px;margin-bottom:20px">
                  <el-input v-model="updateBaseInfo.address" type="textarea"></el-input>
                </el-form-item>
                <el-form-item label="邮政编码" prop="zipCode" style="width: 600px">
                  <el-input v-model="updateBaseInfo.zipCode"></el-input>
                </el-form-item>
                <!-- <div class="tips" v-if="baseInfo.isCert">请前往"企业实名认证"进行修改</div> -->
              </div>
              <div class="btndiv" v-if="!show">
                <button class="btn" type="button" tag="button" @click="cancle">取消</button>
                <button class="btn subbtn" type="button" @click="updateCompany">保存</button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="ibox">
      <div class="table">
        <h4>企业实名认证</h4>
      </div>
      <div class="show">
        <div class="aitem" v-if="authState === null || authState === -1 || authState === 11">
          <div class="i_title"  >企业实名认证:</div>
          <div class="i_content flex-a-c">
            <i class="el-icon-warning"></i>
            <span class="phrase">您尚未完成企业身份验证</span>
          </div>
          <span class="hook"></span>
          <el-button type="text" size="mini" @click="toIndex()">前往认证</el-button>
        </div>
        <div class="aitem" v-if="authState === 0">
          <div class="i_title">企业实名认证:</div>
          <div class="i_content flex-a-c">
            <span class="phrase">{{baseInfo.companyName}}</span>
            <span class="yellow">认证失败</span>
          </div>
          <span class="hook"></span>
          <el-button type="text" size="mini" @click="renewAuth(0)">重新认证</el-button>
        </div>
        <div class="aitem" v-if="authState === 1">
          <div class="i_title">企业实名认证:</div>
          <div class="i_content flex-a-c">
            <span class="phrase">{{baseInfo.companyName}}</span>
            <span class="yellow">企业信息验证校验成功，请点击高级认证...</span>
          </div>
          <span class="hook"></span>
          <el-button type="text" size="mini" @click="toCerts(1)">高级认证</el-button>
          <el-button type="text" size="mini" @click="renewAuth(1)">重新认证</el-button>
        </div>
        <div class="aitem" v-if="authState === 2">
          <div class="i_title">企业实名认证:</div>
          <div class="i_content flex-a-c">
            <span class="phrase">{{baseInfo.companyName}}</span>
            <span class="yellow">打款中...</span>
          </div>
          <span class="hook"></span>
          <el-button type="text" size="mini" @click="amount()">提交金额</el-button>
          <el-button type="text" size="mini" @click="renewAuth(1)">重新认证</el-button>
        </div>
        <div class="aitem" v-if="authState === 3">
          <div class="i_title">企业实名认证:</div>
          <div class="i_content flex-a-c">
            <span class="phrase">{{baseInfo.companyName}}</span>
            <span class="red">打款失败</span>
          </div>
          <span class="hook"></span>
          <el-button type="text" size="mini" @click="toCerts(1)">重新打款</el-button>
          <el-button type="text" size="mini" @click="renewAuth(1)">重新认证</el-button>
        </div>
        <div class="aitem" v-if="authState === 4">
          <div class="i_title">企业实名认证:</div>
          <div class="i_content flex-a-c">
            <i class="el-icon-keys"></i>
            <span class="phrase">我们已经向您公司账户打了一笔随机数额的款项，请将收到的款项数额反馈给我们，以完成身份验证</span>
          </div>
          <span class="hook"></span>
          <el-button type="text" size="mini" @click="amount()">提交金额</el-button>
          <el-button type="text" size="mini" @click="renewAuth(1)">重新认证</el-button>
        </div>
        <div class="aitem" v-if="authState === 5">
          <div class="i_title">企业实名认证:</div>
          <div class="i_content flex-a-c">
            <span class="phrase">{{baseInfo.companyName}}</span>
            <span class="red">验证打款金额失败</span>
          </div>
          <span class="hook"></span>
          <el-button type="text" size="mini" @click="amount()">重新提交金额</el-button>
          <el-button type="text" size="mini" @click="renewAuth(1)">重新认证</el-button>
        </div>
        <div class="aitem" v-if="authState === 6 || authState === 9">
          <div class="i_title">企业实名认证:</div>
          <div class="i_content flex-a-c">
            <span class="phrase">{{baseInfo.companyName}}</span>
            <span class="green">认证成功</span>
          </div>
          <span class="hook"></span>
        </div>

        <div class="aitem" v-if="authState === 7 || authState === 12">
          <div class="i_title">企业实名认证:</div>
          <div class="i_content flex-a-c">
            <span class="phrase">{{baseInfo.companyName}}</span>
            <span class="yellow">线下实名审核中...</span>
          </div>
        </div>
        <div class="aitem" v-if="authState === 7 || authState === 12">
          <div class="air"></div>
          <div class="child">
            <div class="i_title">销售顾问:</div>
            {{salesperson}}
          </div>
          <div class="child">
            <div class="i_title">联系方式:</div>
            {{salespersonMobile}}
          </div>
          <el-button type="text" size="mini" @click="renewAuth(1)">修改销售顾问信息并重新认证</el-button>
        </div>

        <div class="aitem" v-if="authState === 8">
          <div class="i_title">企业实名认证:</div>
          <div class="i_content flex-a-c">
            <span class="phrase">{{baseInfo.companyName}}</span>
            <span class="red">认证失败</span>
          </div>
          <span class="hook"></span>
          <el-button type="text" size="mini" @click="renewAuth">重新认证</el-button>
        </div>
        <div class="aitem" v-if="authState === 10">
          <div class="i_title">企业实名认证:</div>
          <div class="i_content flex-a-c">
            <span class="phrase">{{baseInfo.companyName}}</span>
            <span class="red">认证已驳回， 可发起重新认证</span>
          </div>
          <span class="hook"></span>
          <el-button type="text" size="mini" @click="renewAuth">重新认证</el-button>
        </div>
      </div>
    </div> -->
    </div>
   
    </div>
 
  </div>
</template>

<script>
// import axios from '../axios.js'
import { chinaData } from "../china.js";
export default {
  name: "SsgCompanySet",
  data() {
    return {
      status:false,
      rules: {
        company_name: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "blur",
          },
        ],
        alias_name: [
          {
            required: true,
            message: "请输入企业简称",
            trigger: "blur",
          },
        ],
        industry_name: [
          {
            required: true,
            message: "请输入企业所属行业",
            trigger: "change",
          },
        ],
        scale: [
          {
            required: true,
            message: "请选择企业规模",
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "请输入详细地址",
            trigger: "blur",
          },
        ],
      },
      avatarurl:
        "http://thirdwx.qlogo.cn/mmopen/YcibFq8RBAPicOtn0aacJ5FdJUOsaP21uFHuSF3yM4bXrVHI3nMqaSOX0U0TxQvabq7tA4SKRE3ic9r4qlB3LRyJehDhFbBzK0I/132",
      show: true,
      baseInfo: {
        // isCert: false,
        industryName: "",
      },
      updateBaseInfo: {},
      baseInfos: {},
      options: chinaData(),
      industrylist: [
        {
          id: 15,
          general: "IT,通信,电子,互联网",
          individual: [
            "互联网/电子商务",
            "计算机服务（系统/数据/维护）",
            "计算机硬件",
            "通信/电信运营、增值服务",
            "计算机软件",
            "电子技术/半导体/集成电路",
            "通信/电信/网络设备",
            "网络游戏",
          ],
        },
        {
          id: 16,
          general: "金融业",
          individual: [
            "基金/证券/期货/投资",
            "银行",
            "保险",
            "信托/担保/拍卖/典当",
          ],
        },
        {
          id: 17,
          general: "房地产,建筑业",
          individual: [
            "房地产/建筑/建材/工程",
            "物业管理/商业中心",
            "家居/室内设计/装饰装潢",
          ],
        },
        {
          id: 18,
          general: "商业服务",
          individual: [
            "专业服务/咨询(财会/法律/人力资源等)",
            "中介服务",
            "外包服务",
            "广告/会展/公关/市场推广",
            "检验/检测/认证",
          ],
        },
        {
          id: 19,
          general: "贸易,批发,零售,租赁业 ",
          individual: [
            "快速消费品（食品/饮料/烟酒/日化）",
            "贸易/进出口",
            "租赁服务",
            "耐用消费品（服饰/纺织/皮革/家具/家电等）",
            "零售/批发",
          ],
        },
        {
          id: 20,
          general: "教育,培训",
          individual: ["教育/培训/院校"],
        },
        {
          id: 21,
          general: "生产,加工,制造",
          individual: [
            "汽车/摩托车制造与零配件",
            "加工制造（原料加工/模具）",
            "印刷/包装/造纸",
            "医药/生物工程",
            "航空/航天研究与制造",
            "大型设备/机电设备/重工业",
            "仪器仪表/工业自动化",
            "办公用品及设备",
            "医疗设备/器械",
          ],
        },
        {
          id: 22,
          general: "交通,运输,物流,仓储",
          individual: ["交通/运输/物流/仓储", "航天/航空"],
        },
        {
          id: 23,
          general: "服务业",
          individual: [
            "医疗/护理/美容/保健/卫生服务",
            "旅游/度假/酒店/餐饮",
            "生活服务",
          ],
        },
        {
          id: 24,
          general: "文化,传媒,娱乐,体育",
          individual: ["媒体/出版/影视/文化传播", "娱乐/体育/休闲"],
        },
        {
          id: 25,
          general: "能源,矿产,环保",
          individual: [
            "能源/石油/化工/矿产/地质/采掘/冶炼",
            "电气/电力/水利",
            "环保",
          ],
        },
        {
          id: 26,
          general: "政府,非盈利机构",
          individual: ["政府/公共事业/非盈利机构", "学术/科研"],
        },
        {
          id: 27,
          general: "农,林,牧,渔",
          individual: ["农/林/牧/渔", "跨领域经营"],
        },
        {
          id: 28,
          general: "其他",
          individual: ["其他"],
        },
      ],
      checkid: "1",

      scales: [
        {
          value: "100人以下",
          lable: "100人以下",
        },
        {
          value: "100~300人",
          label: "100~300人",
        },
        {
          value: "300~1000人",
          label: "300~1000人",
        },
        {
          value: "1000人以上",
          label: "1000人以上",
        },
      ],
      region: [],
      editShow: 1,
      authState: -1,
      salesperson: "",
      salespersonMobile: "",
      authId: 0,
      companyName: "",
      maskshow: false,
      inshow: false,
      money: "",
      checkindividual: "",
      searchtext: "",
    };
  },
  computed: {
    get_list: function () {
      var arr = [];
      this.industrylist.forEach((c) =>
        c.individual.forEach((t) => arr.push(t))
      );
      return arr;
    },
  },
  mounted() {
    this.list = this.$route.query;
  },
  created() {
    this.loadCurrentCompanyInfo();
    this.loadAuthzInfo();
  },
  methods: {
    cancle() {
      this.show = true;
      // this.baseInfo.aliasName = this.baseInfos.aliasName
      this.loadCurrentCompanyInfo();
    },

    back() {
      this.$router.push({ path: "/main" });
    },
    deletein() {
      this.checkindividual = "";
    },
    oncheck(i) {
      this.checkindividual = i;
      this.searchtext = "";
    },
    onchecked(id) {
      this.checkid = id;
    },
    hidemask() {
      this.inshow = false;
      this.checkindividual = "";
    },
    onindustry() {
      this.baseInfo.industryName = this.checkindividual;
      this.inshow = false;
    },
    onshut() {
      this.inshow = false;
      this.checkindividual = "";
    },
    hideindu(e) {
      e.stopPropagation();
    },
    ishow() {
      this.inshow = true;
    },
    loadCurrentCompanyInfo() {
      this.$axios.get("/company/info").then((res) => {
        if (res.data.status == 1) {
          this.baseInfo = res.data.data;
          this.baseInfos = res.data.data;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    loadAuthzInfo() {
      this.$axios.get("/company/authStatus").then((res) => {
        if (res.data.status == 1) {
          this.authId = res.data.data.id;
          this.companyName = res.data.data.companyName;
          this.authState = res.data.data.status;
          this.salesperson = res.data.data.salesperson;
          this.salespersonMobile = res.data.data.salespersonMobile;
        }else if(res.data.status == 2){
						this.status =true

        }
      });
    },
    updateCompany() {
      this.$refs.edit.validate((valid) => {
        if (valid) {
          let cityName = "";
          if (this.region.length > 0) {
            cityName = this.region.join(",");

          }
          Object.assign(this.updateBaseInfo, {
            region: cityName,
          });
          this.$axios
            .put("/company/update", this.updateBaseInfo)
            .then((res) => {
              if (res.data.status == 1) {
                this.$message.success("企业编辑成功");
                this.show = true;
                this.loadCurrentCompanyInfo();
                this.loadAuthzInfo();
              } else {
                this.$message.error(res.data.message);
              }
            });
        }
      });
    },
    onshow(obj) {
      // if (obj.editShow == 1) {
      if (this.baseInfos.region) {
        this.region = this.baseInfos.region.split(",");
      }
      this.show = false;
      this.editShow = 0;
      this.updateBaseInfo = this.baseInfos;

      // } else {
      // 	// this.updateBaseInfo = this.baseInfo
      // 	this.show = true;
      // 	this.editShow = 1
      // }
    },
    toCerts(state) {
      const param = {};
      param.id = this.authId;
      param.companyId = this.baseInfo.id;
      param.name = this.companyName;
      param.typesOf = 1;
      let toPage = "Index";
      if (state === 0) {
        toPage = "LicenceCllect";
      } else if (state === 1) {
        toPage = "AccountCllect";
      }
      this.$router.push({
        name: toPage,
        query: param,
      });
    },
    renewAuth(num) {
      const param = {};
      param.id = this.authId;
      this.$axios
        .post("/companyContract/resetAuthStatus", param)
        .then((res) => {
          if (res.data.status == 1) {
            this.$router.push({
              path:
                "/index?id=" +
                this.authId +
                "&name=" +
                this.baseInfo.companyName,
            });
            this.$message.success("企业重新认证");
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    toIndex() {
      this.$router.push({
        path: "/index?id=" + this.authId + "&name=" + this.baseInfo.companyName,
      });
    },

    amount() {
      this.maskshow = true;
    },

    shutmount() {
      this.maskshow = false;
    },

    onmoney() {
      if (this.money) {
        const params = {};
        params.id = this.authId;
        params.cash = this.money;
        this.$axios.post("/companyContract/validCash", params).then((res) => {
          if (res.data.status == 1) {
            this.$message.success("企业实名认证成功");
            this.shutmount();
            this.loadCurrentCompanyInfo();
            this.$parent.$parent.$parent.$parent.$parent.onstatus();
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else {
        this.$message.warning("请填写您收到的款项金额");
      }
    },
  },
};
</script>

<style src="../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../assets/css/common/form.less" scoped lang="less"></style>
<style src="../../assets/css/common/details.less" scoped lang="less"></style>
<style src="../../assets/css/common/additional.less" scoped lang="less"></style>
<style lang="less" scoped>
.ibox:first-child {
  border-top: 0;
}

.ibox .show .item {
  width: 100%;
  margin-bottom: 20px;
}

.avatar {
  width: 170px;
  height: 170px;
  border-radius: 5px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(../../assets/img/qymr.png);
}

.coding {
  width: 100%;
  text-align: center;
  font-size: 14px;

  p:first-child {
    margin: 15px 0;
  }

  p:last-child {
    font-weight: bolder;
  }
}

.dataitems {
  width: 500px;
  margin-left: 30px;
}

.tips {
  position: absolute;
  top: 10px;
  right: 2%;
}

.aitem {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .i_title {
    font-weight: bold;
    color: #9393a2;
    margin-right: 7px;
  }

  .flex-a-c {
    display: flex;
    align-items: center;

    .phrase {
      color: #545566;
    }
  }

  button {
    margin-left: 20px;
    color: #6863e0;
  }

  .air {
    width: 83px;
  }

  .child {
    display: flex;
    align-items: center;
    margin-right: 25px;
  }
}

.mtitle {
  width: 100%;
  margin: 40px 0 20px;
  font-size: 14px;
}

.minput {
  margin-bottom: 48px;
  position: relative;

  .left {
    top: 6px;
    left: 10px;
    font-size: 14px;
    position: absolute;
  }

  .right {
    top: 6px;
    right: 12px;
    font-size: 14px;
    position: absolute;
  }
}

.minput /deep/ .el-input__inner {
  padding: 0 30px;
}

.operating {
  cursor: pointer;
  width: 64px;
  height: 32px;
  border-radius: 4px;
  border: 1px solid rgba(102, 105, 227, 1);
  color: #6669e3;
  line-height: 32px;
  text-align: center;
  font-size: 12px;
}
.message {
  font-size: 12px;
  font-weight: 400;
  color: rgba(84, 85, 102, 1);
  line-height: 18px;
}
.box {
  display: flex;
  margin-top: 20px;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .contract {
    margin-right: 20px;

    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}
.mainTitle {
  font-size: 24px;
  font-weight: bold;
  color: rgba(48, 49, 64, 1);
  margin: 33px 0;
}
.mask {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 15000;
  overflow: hidden;
}

.industrydiv {
  width: 720px;
  height: 508px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -254px;
  margin-left: -360px;
  border-radius: 6px;
}

.industrydiv .industrydiv_top {
  width: 100%;
  height: 110px;
  border-bottom: 1px solid #dfdfdf;
  padding: 0 25px;
  box-sizing: border-box;
}

.industrydiv .industrydiv_top .header {
  width: 100%;
  height: 57px;
  display: flex;
  align-items: center;
}

.industrydiv .industrydiv_top .header .h4 {
  width: 50%;
}

.industrydiv .industrydiv_top .header .h4 h4 {
  font-size: 18px;
  font-weight: bold;
}

.industrydiv .industrydiv_top .header .shut {
  width: 50%;
  display: flex;
  flex-direction: row-reverse;
}

.industrydiv .industrydiv_top .header .shut div {
  width: 12px;
  height: 12px;
  background-image: url(../../assets/img/cha.png);
  background-size: cover;
  cursor: pointer;
}

.industrydiv .industrydiv_top .search {
  width: 100%;
  height: 34px;
  display: flex;
  align-items: center;
  position: relative;
}

.industrydiv .industrydiv_top .search .searchinput {
  width: 570px;
  height: 34px;
  box-sizing: border-box;
  border: 1px solid #bfbfbf;
  border-radius: 6px;
  padding: 0 5px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-right: 14px;
}

.industrydiv .industrydiv_top .search .searchinput .in_boxs {
  display: flex;
  align-items: center;
}

.industrydiv .industrydiv_top .search .searchinput .in_boxs .in_box {
  width: auto;
  display: flex;
  align-items: center;
  height: 22px;
  background-color: #6669e3;
  color: #fff;
  padding: 0 5px;
  border-radius: 4px;
}

.industrydiv .industrydiv_top .search .searchinput .in_boxs .in_box .text {
  height: 22px;
  line-height: 22px;
  text-align: center;
  font-size: 12px;
}

.industrydiv .industrydiv_top .search .searchinput .in_boxs .in_box span {
  cursor: pointer;
  font-size: 18px;
}

.industrydiv .industrydiv_top .search .searchinput input {
  width: 570px;
  height: 32px;
  border-radius: 6px;
  border: none;
  margin: 0 8px;
  box-sizing: border-box;
  font-size: 14px;
  // background-image: url(../../assets/img/ss.png);
  background-size: 16px;
  background-repeat: no-repeat;
  background-position: right center;
}

.industrydiv .industrydiv_top .search button {
  border: none;
  height: 34px;
  padding: 0 15px;
  border-radius: 6px;
  min-width: 84px;
  color: #fff;
  font-size: 14px;
  background-color: #6669e3;
  cursor: pointer;
  float: right;
}

.industrydiv .industrydiv_top .search button:hover {
  background-color: #8285ff;
}

.industrydiv .industrydiv_top .search button:active {
  background-color: #5658c5;
}

.industrydiv .industrydiv_top .search .searchresult {
  width: 568px;
  overflow: auto;
  max-height: 200px;
  background-color: #fff;
  position: absolute;
  top: 33px;
  left: 0;
  border: 1px solid #bfbfbf;
}

.industrydiv .industrydiv_top .search .searchresult ul {
  width: 100%;
  box-sizing: border-box;
}

.industrydiv .industrydiv_top .search .searchresult ul li {
  font-size: 14px;
  padding: 13px;
}

.industrydiv .industrydiv_top .search .searchresult ul li:hover {
  background-color: #f8f8f8;
}

.industrydiv .industrydiv_top .search .searchresult ul .exist {
  color: #6669e3;
}

.industrydiv .industry_main {
  width: 100%;
  height: 395px;
  box-sizing: border-box;
  display: flex;
}

.industrydiv .industry_main .industrydiv_left {
  width: 215px;
  height: 100%;
  padding-left: 26px;
  box-sizing: border-box;
}

.industrydiv .industry_main .industrydiv_left ul {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-top: 20px;
  box-sizing: border-box;
}

.industrydiv .industry_main .industrydiv_left ul li {
  margin-bottom: 13px;
  cursor: pointer;
}

.industrydiv .industry_main .industrydiv_left ul li span {
  display: inline-block;
  height: 14px;
  line-height: 14px;
  border-right: 1px solid #bfbfbf;
  padding: 0 6px;
  color: #8b8b8b;
  font-size: 14px;
}

.industrydiv .industry_main .industrydiv_left ul li span:last-child {
  border-right: none;
}

.industrydiv .industry_main .industrydiv_left ul li span:first-child {
  padding-left: 0;
}

.industrydiv .industry_main .industrydiv_left ul .checked {
  background-image: url(../../assets/img/bg_yellor.png);
  background-size: 7px auto;
  background-repeat: no-repeat;
  background-position: 178px center;
}

.industrydiv .industry_main .industrydiv_left ul .checked span {
  font-weight: bold;
  color: #000000;
}

.industrydiv .industry_main .industrydiv_right {
  width: 505px;
  height: 100%;
  background-color: #f2f2f5;
}

.industrydiv .industry_main .industrydiv_right ul {
  width: 100%;
  // height: 100%;
  box-sizing: border-box;
  padding: 20px 25px;
  font-size: 14px;
  display: flex;
  flex-wrap: wrap;
}

.industrydiv .industry_main .industrydiv_right ul li {
  // display: inline-block;
  width: 45%;
  margin-bottom: 12px;
  cursor: pointer;
  height: 40px;
  margin-right: 10px;
}

.industrydiv .industry_main .industrydiv_right ul .checked {
  color: #6669e3;
}
.ibox .edit[data-v-6c99882d] {
  width: 100%;
  background-color: #f2f5f8;
  padding-top: 40px;
  border-radius: 6px;
}
// .industrydiv .industrydiv_top .search .searchinput input[data-v-294b4432] {
//     width: 570px;
//     height: 32px;
//     border-radius: 6px;
//     border: none;
//     margin: 0 8px;
//     box-sizing: border-box;
// 	font-size: 14px;
// 	background-image: url('');
//     background-size: 16px;
//     background-repeat: no-repeat;
//     background-position: 100%;
// }
.centerConter {
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #8b8b8b;
}
.authority{
				width:100%;
				height:100%;
				display: flex;
        justify-content: center;
        margin:100px auto;
				.content{
					text-align:center;
					margin: 50px auto;
                   font-size: 24px;
				   font-weight:bold;
				   color: #303140;
					
				}
				
			}
      
</style>
